import './purchaseCallToAction.scss';

import { FormattedMessage } from 'react-intl';
import { Button, ButtonColor, Size } from '@eliberty/design-system-react';

export interface PurchaseCallToActionContent {
  /** CTA block title */
  title?: string;
  /** CTA block subtitle / description */
  subtitle?: string;
  /** Button label */
  buttonLabel?: string;
}

export interface PurchaseCallToActionProps {
  /** CMS-driven content (title, subtitle, button label). Falls back to i18n defaults. */
  content?: PurchaseCallToActionContent;
  /** Called when the user clicks the CTA button */
  onClick: () => void;
}

/**
 * PurchaseCallToAction — CTA block displayed over the product image on desktop.
 *
 * Content (title, subtitle, button label) is customisable via CMS.
 * When not provided, falls back to default translated strings.
 */
const PurchaseCallToAction = ({ content, onClick }: PurchaseCallToActionProps) => {
  const title = content?.title ?? undefined;
  const subtitle = content?.subtitle ?? undefined;
  const buttonLabel = content?.buttonLabel ?? undefined;

  return (
    <div className='PurchaseCallToAction' data-testid='PurchaseCallToAction'>
      <h2 className='PurchaseCallToAction_title'>
        {title ?? (
          <FormattedMessage id='purchaseCallToAction.title' defaultMessage='Purchase & Recharge' />
        )}
      </h2>
      <p className='PurchaseCallToAction_subtitle'>
        {subtitle ?? (
          <FormattedMessage
            id='purchaseCallToAction.subtitle'
            defaultMessage='Choose your dates and the number of participants for an immediate purchase or recharge.'
          />
        )}
      </p>
      <div className='PurchaseCallToAction_button'>
        <Button
          size={Size.L}
          color={ButtonColor.Primary}
          onClick={onClick}
          fullWidth
          data-testid='PurchaseCallToAction_button'
        >
          {buttonLabel ?? (
            <FormattedMessage id='purchaseCallToAction.buttonLabel' defaultMessage='Book now' />
          )}
        </Button>
      </div>
    </div>
  );
};

export default PurchaseCallToAction;
